import './Accomodation.css';
import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import {
  MapPin,
  Clock,
  Info,
  Coffee,
  Wifi,
  Car,
  Building2,
  Utensils,
  Dumbbell,
  Heart,
  CalendarCheck,
  AlertCircle,
  BadgeCheck,
  Bath,
  Home,
  ShieldCheck,
  ExternalLink
} from 'lucide-react';

const Accommodation = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const hotels = [
    {
      id: 1,
      name: "ITC Windsor Manor",
      category: "5★ Deluxe",
      website: "https://www.itchotels.com/in/en/itcwindsor-bengaluru",
      distance: "3 km from Venue",
      description: "Experience signature hospitality with elegant rooms, fine dining, and premium facilities.",
      
      amenities: [
        { name: "Breakfast Included", icon: Coffee },
        { name: "Premium Service", icon: ShieldCheck },
        { name: "Fine Dining", icon: Utensils },
        { name: "Fitness Center", icon: Dumbbell },
        { name: "Airport Transfer", icon: Car }
      ]
    },

    {
      id: 3,
      name: "The Lalit Ashok",
      category: "5★",
      website: "https://www.thelalit.com/",
      distance: "3 km from Venue",
      description: "Elegant stay featuring refined service, grand interiors, and a blend of comfort and class.",
      
      amenities: [
        { name: "Breakfast Included", icon: Coffee },
        { name: "Luxury Rooms", icon: Heart },
        { name: "Multi-cuisine Dining", icon: Utensils },
        { name: "Conference Facilities", icon: Building2 },
        { name: "Premium WiFi", icon: Wifi }
      ]
    },
    {
      id: 4,
      name: "The Solitaire Hotel",
      category: "4★",
      website: "https://the-solitaire.hotels-in-bangalore.com/en/",
      distance: "4 km from Venue",
      description: "Business-friendly hotel with modern amenities and excellent value.",
      
      amenities: [
        { name: "Breakfast Included", icon: Coffee },
        { name: "WiFi Access", icon: Wifi },
        { name: "Business Services", icon: Building2 },
        { name: "Restaurant", icon: Utensils },
        { name: "Shuttle Service", icon: Car }
      ]
    },
    {
      id: 5,
      name: "Hotel Monarch Luxor",
      category: "4★",
      website: "https://www.monarchhotels.in/",
      distance: "4 km from Venue",
      description: "Comfortable, business-friendly rooms in a well-connected part of the city.",
      
      amenities: [
        { name: "Breakfast Included", icon: Coffee },
        { name: "WiFi", icon: Wifi },
        { name: "Business Center", icon: Building2 },
        { name: "Dining", icon: Utensils },
        { name: "Parking", icon: Car }
      ]
    },
    {
      id: 6,
      name: "Radisson Blu Atria Bengaluru",
      category: "5★",
      website: "https://www.radissonhotels.com/en-us/hotels/radisson-blu-bengaluru-atria",
      distance: "4-5 km from Venue",
      description: "Eco-friendly service apartments providing comfort and self-catering options.",
      
      amenities: [
        { name: "Breakfast ", icon: Coffee },
        { name: "Dining", icon: Utensils },
        { name: "WiFi", icon: Wifi },
        { name: "Workspace", icon: Building2 },
        { name: "Premium Facilities", icon: Home },
        { name: "Parking", icon: Car }
      ]
    },
    {
      id: 7,
      name: "Four Seasons",
      category: "5★",
      website: "https://www.fourseasons.com/bengaluru/",
      distance: "4 km from Venue",
      description: "A Luxury Business Hotel in the Heart of Bengaluru",
      
      amenities: [
        { name: "Breakfast Included", icon: Coffee },
        { name: "WiFi Access", icon: Wifi },
        { name: "Work Desk", icon: Building2 },
        { name: "Local Transport", icon: Car },
        { name: "Business Center", icon: Building2 },
      ]
    },
    

    {
  id: 8,
  name: "Sheraton Grand Bangalore Hotel at Brigade Gateway",
  category: "5★",
  website: "https://www.marriott.com/en-us/hotels/blrgs-sheraton-grand-bangalore-hotel-at-brigade-gateway/overview/",
  distance: "3.8 km from Venue", // please adjust as needed
  description: "A luxury 5-star retreat with infinity outdoor pool, spa, fitness, multiple dining options, and direct access to a shopping mall.",
  amenities: [
    { name: "Outdoor Infinity Pool", icon: Bath },
    { name: "Children's Pool", icon: Bath },
    { name: "Spa & Shine Spa", icon: Bath },
    { name: "Fitness Center", icon: Dumbbell },
    { name: "Multiple Restaurants", icon: Utensils },
    { name: "Coffee Shops & Bakery", icon: Coffee },
    { name: "Club Lounge", icon: Heart },
    { name: "Free Wi-Fi", icon: Wifi },
    { name: "Free Parking", icon: Car },
    { name: "EV Charging Station", icon: Car },
    { name: "Business & Meeting Spaces", icon: Building2 },
    { name: "Concierge & Luggage Storage", icon: ShieldCheck },
    { name: "Express Check-In/Out", icon: Clock }
  ]
},

    {
  id: 9,
  name: "De Mandarin, Bengaluru",
  category: "3★",
  website: "https://www.demandarin.in/de-mandarin-bengaluru/",
  distance: "2.3 km from Venue",
  description: "Boutique hotel on New BEL Road offering cozy rooms with balconies, a rooftop restaurant, and warm hospitality.",
  amenities: [
    { name: "Free Wi-Fi", icon: Wifi },
    { name: "Restaurant & In-Room Breakfast", icon: Utensils },
    { name: "Free Parking", icon: Car },
    { name: "Meeting & Banquet Facilities", icon: Building2 },
    { name: "Children's Menu & Board Games", icon: Heart },
    { name: "24-hour Reception & Room Service", icon: Clock },
    { name: "Air Conditioning", icon: Home },
    { name: "Mini-Bar", icon: Coffee },
    { name: "Tea/Coffee Facilities", icon: Coffee }
  ]
},

    {
  id: 10,
  name: "Hyatt Centric MG Road Bengaluru",
  category: "5★",
  website: "https://www.hyatt.com/hyatt-centric/en-US/blrhy-hyatt-centric-mg-road-bangalore/",
  distance: "10 km from Venue",
  description: "Upscale modern hotel with spa, fitness, outdoor pool, business services, and free breakfast—ideal for both business and leisure.",
  amenities: [
    { name: "Outdoor Pool", icon: Bath },
    { name: "Spa & Wellness Centre", icon: Bath },
    { name: "Fitness Center", icon: Dumbbell },
    { name: "Restaurant & Bar/Lounge", icon: Utensils },
    { name: "Free Wi-Fi", icon: Wifi },
    { name: "Free Parking", icon: Car },
    { name: "Mini-Bar & Coffee Maker", icon: Coffee },
    { name: "Air Conditioning", icon: Home },
    { name: "Business Centre & Meeting Rooms", icon: Building2 },
    { name: "24-hour Room Service", icon: Clock },
    { name: "Laundry Service", icon: AlertCircle },
    { name: "In-Room Fridge", icon: Coffee },
    { name: "Safe Box", icon: ShieldCheck }
  ]
},
{
  id: 11,
  name: "Taj West End, Bengaluru",
  category: "5★ (heritage)",
  website: "https://www.tajhotels.com/en-in/hotels/taj-west-end-bengaluru",
  distance: "6.2 km from Venue",
  description: "Historic 5-star heritage hotel set among 20 acres of lush gardens, offering heritage charm, spa, outdoor pool, tennis, fine dining, and extensive business facilities.",
  amenities: [
    { name: "Outdoor Pool & Jacuzzi", icon: Bath },
    { name: "Spa & Sauna", icon: Bath },
    { name: "Fitness Center", icon: Dumbbell },
    { name: "Tennis Courts", icon: Building2 },
    { name: "Restaurants, Lounge & Bar", icon: Utensils },
    { name: "Coffee Shop/Café", icon: Coffee },
    { name: "Free Wi-Fi", icon: Wifi },
    { name: "Free Parking & EV Charging", icon: Car },
    { name: "Butler Service", icon: BadgeCheck },
    { name: "Business Center & Meeting Rooms", icon: Building2 },
    { name: "Laundry & Concierge", icon: ShieldCheck },
    { name: "Garden & Terrace", icon: Home }
  ]
},
{
  id: 14,
  name: "Shangri-La Bengaluru",
  category: "5★",
  website: "https://www.shangri-la.com/bengaluru/shangrila/about/services-facilities/",
  distance: "5.3 km from Venue",
  description: "Luxury 5-star city-scape hotel with multiple dining options, full spa, outdoor pool, health club, family-friendly services, and extensive business amenities.",
  amenities: [
    { name: "Outdoor Pool & Children's Pool", icon: Bath },
    { name: "Full-Service Spa", icon: Bath },
    { name: "24-hour Health Club", icon: Dumbbell },
    { name: "Restaurants, Bars & Café", icon: Utensils },
    { name: "Free Wi-Fi", icon: Wifi },
    { name: "Paid Airport Transfers / Shuttle", icon: Car },
    { name: "Conference Facilities", icon: Building2 },
    { name: "Parking", icon: Car },
    { name: "Non-Smoking Rooms & Safe Deposit", icon: ShieldCheck },
    { name: "Children’s Club & Babysitting", icon: Heart },
    { name: "Laundry", icon: AlertCircle }
  ]
},
{
  id: 15,
  name: "Taj Yeshwantpur, Bengaluru",
  category: "5★",
  website: "https://www.tajhotels.com/en-in/hotels/taj-yeshwantpur-bangalore",
  distance: "6.6 km from Venue", // placeholder—please update as needed
  description: "A modern 5-star hotel with luxurious rooms, expansive event spaces, wellness spa, and eco-friendly hospitality.",
  amenities: [
    { name: "Outdoor Pool", icon: Bath },
    { name: "Children's Pool", icon: Bath },
    { name: "Spa & Wellness Centre", icon: Bath },
    { name: "Fitness Centre", icon: Dumbbell },
    { name: "Restaurants & Bar", icon: Utensils },
    { name: "Airport Shuttle (surcharge)", icon: Car },
    { name: "Free Parking & EV Charging", icon: Car },
    { name: "Business Centre / Banquet Facilities", icon: Building2 },
    { name: "Free Wi-Fi", icon: Wifi },
    { name: "Concierge Services", icon: ShieldCheck },
    { name: "Childcare / Babysitting (surcharge)", icon: Heart }
  ]
},
{
  id: 16,
  name: "Comfort Inn Insys, Bengaluru",
  category: "4★",
  website: "https://www.comfortinn-insys.com/",
  distance: "2.8 km from Venue", // placeholder
  description: "A boutique business hotel offering contemporary rooms, rooftop pool, restaurant, and vibrant nightlife options.",
  amenities: [
    { name: "Rooftop Outdoor Pool", icon: Bath },
    { name: "Restaurant & Pavilion Lounge", icon: Utensils },
    { name: "Bars / Nightclub / Pool-bar", icon: Utensils },
    { name: "Fitness Centre (24-hour)", icon: Dumbbell },
    { name: "Free Wi-Fi", icon: Wifi },
    { name: "Free Private Parking", icon: Car },
    { name: "Airport Transfer (on request)", icon: Car },
    { name: "BBQ Facilities / Garden", icon: Home },
    { name: "24-hour Front Desk", icon: ShieldCheck },
    { name: "Daily Housekeeping", icon: Building2 },
    { name: "Non-Smoking Rooms & Air Conditioning", icon: Home }
  ]
},

{ 
  id: 17, 
  name: "The Nines Business Hotel", 
  category: "3★", 
  website: "https://www.thenineshotels.com/", 
  distance: "2 km from venue", 
  description: "A business-oriented hotel in Mathikere / Yeshwantpur, offering comfortable suites and meeting spaces", 
  amenities: [
    { name: "Free WiFi", icon: Wifi },
    { name: "Restaurant / Dining", icon: Coffee },
    { name: "24-hr Room Service", icon: Building2 },
    { name: "Gym / Fitness Centre", icon: Building2 },
    { name: "Parking", icon: Car },
    { name: "Power Backup", icon: Building2 },
    { name: "Currency Exchange / Tour Desk", icon: Car },
    { name: "Laundry / Dry Clean", icon: Building2 },
  ] 
},
{
  id: 18,
  name: "Parijatha Grand",
  category: "3★",
  website: "https://parijathagrand.com/",
  distance: "2.7 km from venue", 
  description: "A business / mid-range hotel in Rajajinagar, Bangalore, offering comfortable rooms, conference & banquet facilities, and proximity to metro & key city attractions.",
  amenities: [
    { name: "Free WiFi", icon: Wifi },
    { name: "Restaurant / Dining", icon: Coffee },
    { name: "24-hr Room Service", icon: Building2 },
    { name: "Gym / Fitness Centre", icon: Building2 },
    { name: "Parking", icon: Car },
    { name: "Power Backup", icon: Building2 },
    { name: "Laundry / Dry Clean", icon: Building2 },
    { name: "Conference / Meeting Rooms", icon: Building2 },
    { name: "Air Conditioning", icon: Building2 }
  ]
},
{
  id: 19,
  name: "Treebo Galaxy Suites, Mathikere",
  category: "3★ / Budget",
  website: "https://www.treebo.com/hotels-in-bangalore/treebo-galaxy-suites-mathikere-mathikere-2298/",
  distance: "2.2 km from venue",  // (need to compute based on your “venue”)
  description: "A budget / mid-range hotel located in Mathikere (Yeshwanthpur area), Bangalore. Offers comfortable AC rooms, free WiFi, and basic amenities along with banquet facilities for small events.",
  amenities: [
    { name: "Free WiFi", icon: Wifi },
    { name: "Air Conditioning", icon: Building2 },
    { name: "Parking", icon: Car },
    { name: "Power Backup", icon: Building2 },
    { name: "Elevator / Lift", icon: Building2 },
    { name: "Room Service", icon: Building2 },
    { name: "Laundry / Dry Clean", icon: Building2 },
    { name: "Banquet / Meeting Rooms", icon: Building2 }
  ]
}



  ]


  

  return (
    <>
      <Navbar />
      <div className={`accommodation-container ${isVisible ? "fade-in" : ""}`}>
        <section className="intro-section">
          <h1 className="accommodation-title">Accommodation Options</h1>
          <p className="accommodation-subtext">
            Delegates can choose from a variety of hotel options, all located within close proximity to the conference venue.
          </p>

        
        </section>

        <section className="hotels-section">
  {hotels.map((hotel, idx) => (
    <div key={hotel.id} className="hotel-card" style={{ animationDelay: `${idx * 0.1}s` }}>
      <div className="hotel-header">
        <span className="hotel-category">{hotel.category}</span>
        <span className="hotel-distance"><MapPin size={14} /> {hotel.distance}</span>
      </div>

      <h2 className="hotel-name">{hotel.name}</h2>
      <p className="hotel-description">{hotel.description}</p>

      <div className="amenities-list">
        {hotel.amenities.map((a, i) => (
          <div key={i} className="amenity">
            <a.icon size={16} />
            <span>{a.name}</span>
          </div>
        ))}
      </div>

      

        <button
          className="book-button"
          onClick={() => window.open(hotel.website, "_blank")}
        >
          Book Now <ExternalLink size={16} />
        </button>
      </div>
   
  ))}
</section>


        
      </div>
      <br />
      <br />
      <Footer />
    </>
  );
};

export default Accommodation;
